// eslint-disable-next-line import/prefer-default-export
export const getGdocApiUrl = (url) => {
  const arr = url.split('d/')
  const docIdFragment = arr[arr.length - 1]
  const fragemntArr = docIdFragment.split('/')
  const docId = fragemntArr?.[0] ?? docIdFragment
  const apiUrl = `https://docs.google.com/feeds/download/documents/export/Export?id=${docId}&exportFormat=html`
  return apiUrl
}
